import { DirectionalCostBase } from './base/directional-cost-base';

export class DirectionalCost extends DirectionalCostBase { }